import { FC } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Box, Checkbox, InputLabel, Modal, Text } from '@hopskipdrive/react-components';
import { Button } from '@rideiq/shared/components/Button';

interface DashcamNotificationModalProps {
  isOpen: boolean;
  handleSave: () => void;
  handleClose: () => void;
}

export const DashcamNotificationModal: FC<DashcamNotificationModalProps> = ({ isOpen, handleSave, handleClose }) => {
  const { control, handleSubmit, watch } = useForm<{ acknowledged: boolean }>({
    defaultValues: { acknowledged: false },
  });

  const acknowledged = watch('acknowledged');

  const onSubmit = () => {
    if (acknowledged) {
      handleSave();
    }
  };

  return (
    <Modal data-testid="dashcam-notification-modal" open={isOpen} onClose={handleClose}>
      <form id="rides-form" onSubmit={handleSubmit(onSubmit)}>
        <Modal.Title>Ride Recording: Dashcam Consent</Modal.Title>
        <Modal.Content>
          <Text>
            This ride will be recorded. At least one rider on this ride does not have Ride Recording: Dashcam as a
            service. Please check the box below to acknowledge your consent for all passengers to be recorded.
          </Text>
          <Controller
            name="acknowledged"
            control={control}
            render={({ field }) => (
              <Box mt={4} display="flex" alignItems="center">
                <Checkbox {...field} id="acknowledged-checkbox" data-testid="mustBeMet" checked={field.value} />
                <InputLabel htmlFor="acknowledged-checkbox">
                  I acknowledge and understand the above information.
                </InputLabel>
              </Box>
            )}
            rules={{ required: true }}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button color="tertiary" onClick={handleClose} type="button">
            Nevermind
          </Button>
          <Button color="primary" variant="contained" type="submit" disabled={!acknowledged}>
            Save
          </Button>
        </Modal.Actions>
      </form>
    </Modal>
  );
};
